import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePasswordComponent } from './change-password.component';
import { AuthGuard } from '../shared/_guards/auth.guard';


const routes: Routes = [
  { path: 'profile', pathMatch: 'full', component: ChangePasswordComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    AuthGuard
  ]
})
export class ChangePasswordRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/change-password/change-password-routing.module.ts